export const chimeraRawDataTypeValues = [
	'all',
	'boot',
	'mains',
	'power',
	'fault',
	'cell',
	'ack',
	'init',
	'update',
	'milking',
	'pickup',
	'wash',
];

export const classicRawDataTypeValues = ['all', 'NSS', 'SVL', 'BEM', 'BleCap', 'DBG:BLE'];

export type ChimeraRawDataType = typeof chimeraRawDataTypeValues[number];
export type ClassicRawDataType = typeof classicRawDataTypeValues[number];
// Keep each data type separate in navigation and RUM, including Classic types.
export const rawDataTabs = [
	...new Set([...chimeraRawDataTypeValues, ...classicRawDataTypeValues]),
].map(type => ({
	type,
	path: type.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
}));
